
<script>
  export default {
    name: 'BIDemoMenu',
    props: {
        items: {
          type: Array,
          required: false,
          default: () => []
        }
    },
    data: () => ({
      model: 1,
    })
  }
</script>

<template>
  <v-card
    class="mx-auto"
    max-width="500"
  >
    <v-list>
      <v-list-item-group>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>